import { jsxs as y, Fragment as K, jsx as a } from "react/jsx-runtime";
import * as Q from "react";
import Le, { useRef as re, useState as L, useCallback as ue, useEffect as q } from "react";
function Ee(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var se = {}, we;
function Te() {
  if (we) return se;
  we = 1;
  var e = Le;
  function r(d) {
    return d && typeof d == "object" && "default" in d ? d : { default: d };
  }
  var n = /* @__PURE__ */ r(e);
  function l(d, c) {
    for (var f = 0; f < c.length; f++) {
      var t = c[f];
      t.enumerable = t.enumerable || !1, t.configurable = !0, "value" in t && (t.writable = !0), Object.defineProperty(d, t.key, t);
    }
  }
  function h(d, c, f) {
    return c && l(d.prototype, c), d;
  }
  var m = typeof process < "u" && process.env && process.env.NODE_ENV === "production", g = function(d) {
    return Object.prototype.toString.call(d) === "[object String]";
  }, v = /* @__PURE__ */ (function() {
    function d(f) {
      var t = f === void 0 ? {} : f, s = t.name, o = s === void 0 ? "stylesheet" : s, i = t.optimizeForSpeed, p = i === void 0 ? m : i;
      x(g(o), "`name` must be a string"), this._name = o, this._deletedRulePlaceholder = "#" + o + "-deleted-rule____{}", x(typeof p == "boolean", "`optimizeForSpeed` must be a boolean"), this._optimizeForSpeed = p, this._serverSheet = void 0, this._tags = [], this._injected = !1, this._rulesCount = 0;
      var B = typeof window < "u" && document.querySelector('meta[property="csp-nonce"]');
      this._nonce = B ? B.getAttribute("content") : null;
    }
    var c = d.prototype;
    return c.setOptimizeForSpeed = function(t) {
      x(typeof t == "boolean", "`setOptimizeForSpeed` accepts a boolean"), x(this._rulesCount === 0, "optimizeForSpeed cannot be when rules have already been inserted"), this.flush(), this._optimizeForSpeed = t, this.inject();
    }, c.isOptimizeForSpeed = function() {
      return this._optimizeForSpeed;
    }, c.inject = function() {
      var t = this;
      if (x(!this._injected, "sheet already injected"), this._injected = !0, typeof window < "u" && this._optimizeForSpeed) {
        this._tags[0] = this.makeStyleTag(this._name), this._optimizeForSpeed = "insertRule" in this.getSheet(), this._optimizeForSpeed || (m || console.warn("StyleSheet: optimizeForSpeed mode not supported falling back to standard mode."), this.flush(), this._injected = !0);
        return;
      }
      this._serverSheet = {
        cssRules: [],
        insertRule: function(s, o) {
          return typeof o == "number" ? t._serverSheet.cssRules[o] = {
            cssText: s
          } : t._serverSheet.cssRules.push({
            cssText: s
          }), o;
        },
        deleteRule: function(s) {
          t._serverSheet.cssRules[s] = null;
        }
      };
    }, c.getSheetForTag = function(t) {
      if (t.sheet)
        return t.sheet;
      for (var s = 0; s < document.styleSheets.length; s++)
        if (document.styleSheets[s].ownerNode === t)
          return document.styleSheets[s];
    }, c.getSheet = function() {
      return this.getSheetForTag(this._tags[this._tags.length - 1]);
    }, c.insertRule = function(t, s) {
      if (x(g(t), "`insertRule` accepts only strings"), typeof window > "u")
        return typeof s != "number" && (s = this._serverSheet.cssRules.length), this._serverSheet.insertRule(t, s), this._rulesCount++;
      if (this._optimizeForSpeed) {
        var o = this.getSheet();
        typeof s != "number" && (s = o.cssRules.length);
        try {
          o.insertRule(t, s);
        } catch {
          return m || console.warn(`StyleSheet: illegal rule: 

` + t + `

See https://stackoverflow.com/q/20007992 for more info`), -1;
        }
      } else {
        var i = this._tags[s];
        this._tags.push(this.makeStyleTag(this._name, t, i));
      }
      return this._rulesCount++;
    }, c.replaceRule = function(t, s) {
      if (this._optimizeForSpeed || typeof window > "u") {
        var o = typeof window < "u" ? this.getSheet() : this._serverSheet;
        if (s.trim() || (s = this._deletedRulePlaceholder), !o.cssRules[t])
          return t;
        o.deleteRule(t);
        try {
          o.insertRule(s, t);
        } catch {
          m || console.warn(`StyleSheet: illegal rule: 

` + s + `

See https://stackoverflow.com/q/20007992 for more info`), o.insertRule(this._deletedRulePlaceholder, t);
        }
      } else {
        var i = this._tags[t];
        x(i, "old rule at index `" + t + "` not found"), i.textContent = s;
      }
      return t;
    }, c.deleteRule = function(t) {
      if (typeof window > "u") {
        this._serverSheet.deleteRule(t);
        return;
      }
      if (this._optimizeForSpeed)
        this.replaceRule(t, "");
      else {
        var s = this._tags[t];
        x(s, "rule at index `" + t + "` not found"), s.parentNode.removeChild(s), this._tags[t] = null;
      }
    }, c.flush = function() {
      this._injected = !1, this._rulesCount = 0, typeof window < "u" ? (this._tags.forEach(function(t) {
        return t && t.parentNode.removeChild(t);
      }), this._tags = []) : this._serverSheet.cssRules = [];
    }, c.cssRules = function() {
      var t = this;
      return typeof window > "u" ? this._serverSheet.cssRules : this._tags.reduce(function(s, o) {
        return o ? s = s.concat(Array.prototype.map.call(t.getSheetForTag(o).cssRules, function(i) {
          return i.cssText === t._deletedRulePlaceholder ? null : i;
        })) : s.push(null), s;
      }, []);
    }, c.makeStyleTag = function(t, s, o) {
      s && x(g(s), "makeStyleTag accepts only strings as second parameter");
      var i = document.createElement("style");
      this._nonce && i.setAttribute("nonce", this._nonce), i.type = "text/css", i.setAttribute("data-" + t, ""), s && i.appendChild(document.createTextNode(s));
      var p = document.head || document.getElementsByTagName("head")[0];
      return o ? p.insertBefore(i, o) : p.appendChild(i), i;
    }, h(d, [
      {
        key: "length",
        get: function() {
          return this._rulesCount;
        }
      }
    ]), d;
  })();
  function x(d, c) {
    if (!d)
      throw new Error("StyleSheet: " + c + ".");
  }
  function _(d) {
    for (var c = 5381, f = d.length; f; )
      c = c * 33 ^ d.charCodeAt(--f);
    return c >>> 0;
  }
  var w = _, j = function(d) {
    return d.replace(/\/style/gi, "\\/style");
  }, b = {};
  function u(d, c) {
    if (!c)
      return "jsx-" + d;
    var f = String(c), t = d + f;
    return b[t] || (b[t] = "jsx-" + w(d + "-" + f)), b[t];
  }
  function C(d, c) {
    var f = /__jsx-style-dynamic-selector/g;
    typeof window > "u" && (c = j(c));
    var t = d + c;
    return b[t] || (b[t] = c.replace(f, d)), b[t];
  }
  function T(d, c) {
    return c === void 0 && (c = {}), d.map(function(f) {
      var t = f[0], s = f[1];
      return /* @__PURE__ */ n.default.createElement("style", {
        id: "__" + t,
        // Avoid warnings upon render with a key
        key: "__" + t,
        nonce: c.nonce ? c.nonce : void 0,
        dangerouslySetInnerHTML: {
          __html: s
        }
      });
    });
  }
  var S = /* @__PURE__ */ (function() {
    function d(f) {
      var t = f === void 0 ? {} : f, s = t.styleSheet, o = s === void 0 ? null : s, i = t.optimizeForSpeed, p = i === void 0 ? !1 : i;
      this._sheet = o || new v({
        name: "styled-jsx",
        optimizeForSpeed: p
      }), this._sheet.inject(), o && typeof p == "boolean" && (this._sheet.setOptimizeForSpeed(p), this._optimizeForSpeed = this._sheet.isOptimizeForSpeed()), this._fromServer = void 0, this._indices = {}, this._instancesCounts = {};
    }
    var c = d.prototype;
    return c.add = function(t) {
      var s = this;
      this._optimizeForSpeed === void 0 && (this._optimizeForSpeed = Array.isArray(t.children), this._sheet.setOptimizeForSpeed(this._optimizeForSpeed), this._optimizeForSpeed = this._sheet.isOptimizeForSpeed()), typeof window < "u" && !this._fromServer && (this._fromServer = this.selectFromServer(), this._instancesCounts = Object.keys(this._fromServer).reduce(function(O, le) {
        return O[le] = 0, O;
      }, {}));
      var o = this.getIdAndRules(t), i = o.styleId, p = o.rules;
      if (i in this._instancesCounts) {
        this._instancesCounts[i] += 1;
        return;
      }
      var B = p.map(function(O) {
        return s._sheet.insertRule(O);
      }).filter(function(O) {
        return O !== -1;
      });
      this._indices[i] = B, this._instancesCounts[i] = 1;
    }, c.remove = function(t) {
      var s = this, o = this.getIdAndRules(t).styleId;
      if (N(o in this._instancesCounts, "styleId: `" + o + "` not found"), this._instancesCounts[o] -= 1, this._instancesCounts[o] < 1) {
        var i = this._fromServer && this._fromServer[o];
        i ? (i.parentNode.removeChild(i), delete this._fromServer[o]) : (this._indices[o].forEach(function(p) {
          return s._sheet.deleteRule(p);
        }), delete this._indices[o]), delete this._instancesCounts[o];
      }
    }, c.update = function(t, s) {
      this.add(s), this.remove(t);
    }, c.flush = function() {
      this._sheet.flush(), this._sheet.inject(), this._fromServer = void 0, this._indices = {}, this._instancesCounts = {};
    }, c.cssRules = function() {
      var t = this, s = this._fromServer ? Object.keys(this._fromServer).map(function(i) {
        return [
          i,
          t._fromServer[i]
        ];
      }) : [], o = this._sheet.cssRules();
      return s.concat(Object.keys(this._indices).map(function(i) {
        return [
          i,
          t._indices[i].map(function(p) {
            return o[p].cssText;
          }).join(t._optimizeForSpeed ? "" : `
`)
        ];
      }).filter(function(i) {
        return !!i[1];
      }));
    }, c.styles = function(t) {
      return T(this.cssRules(), t);
    }, c.getIdAndRules = function(t) {
      var s = t.children, o = t.dynamic, i = t.id;
      if (o) {
        var p = u(i, o);
        return {
          styleId: p,
          rules: Array.isArray(s) ? s.map(function(B) {
            return C(p, B);
          }) : [
            C(p, s)
          ]
        };
      }
      return {
        styleId: u(i),
        rules: Array.isArray(s) ? s : [
          s
        ]
      };
    }, c.selectFromServer = function() {
      var t = Array.prototype.slice.call(document.querySelectorAll('[id^="__jsx-"]'));
      return t.reduce(function(s, o) {
        var i = o.id.slice(2);
        return s[i] = o, s;
      }, {});
    }, d;
  })();
  function N(d, c) {
    if (!d)
      throw new Error("StyleSheetRegistry: " + c + ".");
  }
  var z = /* @__PURE__ */ e.createContext(null);
  z.displayName = "StyleSheetContext";
  function I() {
    return new S();
  }
  function k(d) {
    var c = d.registry, f = d.children, t = e.useContext(z), s = e.useState(function() {
      return t || c || I();
    }), o = s[0];
    return /* @__PURE__ */ n.default.createElement(z.Provider, {
      value: o
    }, f);
  }
  function A() {
    return e.useContext(z);
  }
  var R = n.default.useInsertionEffect || n.default.useLayoutEffect, F = typeof window < "u" ? I() : void 0;
  function W(d) {
    var c = F || A();
    return c ? typeof window > "u" ? (c.add(d), null) : (R(function() {
      return c.add(d), function() {
        c.remove(d);
      };
    }, [
      d.id,
      String(d.dynamic)
    ]), null) : null;
  }
  return W.dynamic = function(d) {
    return d.map(function(c) {
      var f = c[0], t = c[1];
      return u(f, t);
    }).join(" ");
  }, se.StyleRegistry = k, se.createStyleRegistry = I, se.style = W, se.useStyleRegistry = A, se;
}
var ge, ke;
function Ae() {
  return ke || (ke = 1, ge = Te().style), ge;
}
var Oe = Ae();
const Y = /* @__PURE__ */ Ee(Oe), M = {
  CAMERA: "camera",
  UPLOAD: "upload",
  PREVIEW: "preview",
  UPLOADING: "uploading"
};
function Ue(e = "environment", r, n, l, h, m) {
  const g = re(null), v = re(null), x = re(null), _ = re(null), [w, j] = L(null), [b, u] = L(!1), [C, T] = L(e), [S, N] = L(!1), [z, I] = L(!1), [k, A] = L(!1), R = ue(() => {
    const s = x.current;
    s && (s.getTracks().forEach((o) => o.stop()), x.current = null, _.current = null), g.current && (g.current.srcObject = null, A(!1)), N(!1);
  }, []), F = ue(async () => {
    var s, o;
    try {
      if ((s = navigator.permissions) != null && s.query && (await navigator.permissions.query({
        name: "camera"
      })).state === "denied") {
        h(M.UPLOAD), r(!0);
        return;
      }
      const i = await navigator.mediaDevices.getUserMedia({
        video: {
          facingMode: C
        },
        audio: !1
      });
      x.current = i;
      const p = g.current;
      p && (p.srcObject = i, p.onloadedmetadata = () => {
        A(!0);
      }, await p.play());
      const B = i.getVideoTracks()[0];
      if (B) {
        _.current = B;
        const O = (o = B.getCapabilities) == null ? void 0 : o.call(B);
        I(!!(O != null && O.torch));
      }
      u(!0);
    } catch (i) {
      const p = i;
      ["NotAllowedError", "PermissionDeniedError", "SecurityError"].includes(p.name) && (r(!0), h(M.UPLOAD), R());
    }
  }, [C, r, h, R]), W = ue(async () => {
    var s;
    if ((s = navigator.permissions) != null && s.query)
      try {
        const o = await navigator.permissions.query({
          name: "camera"
        });
        o.onchange = async () => {
          o.state === "denied" ? (R(), u(!1), h(M.UPLOAD), r(!0)) : o.state === "granted" && (r(!1), h(M.CAMERA), await F());
        };
      } catch {
        n(m.unexpectedError);
      }
  }, [F, R, h, r, m, n]);
  return q(() => {
    W();
  }, [W]), q(() => (b || R(), () => {
    R();
  }), [b, R]), q(() => {
    b && (R(), F());
  }, [C, b, F, R]), {
    videoRef: g,
    canvasRef: v,
    image: w,
    facingMode: C,
    switchCamera: () => {
      T((s) => s === "user" ? "environment" : "user");
    },
    captureImage: () => {
      n == null || n(null), h(M.PREVIEW);
      const s = g.current, o = v.current;
      if (!s || !o) return;
      const i = o.getContext("2d");
      i && (o.width = s.videoWidth, o.height = s.videoHeight, i.drawImage(s, 0, 0, o.width, o.height), o.toBlob((p) => {
        if (!p) return;
        w != null && w.startsWith("blob:") && URL.revokeObjectURL(w);
        const B = URL.createObjectURL(p);
        j(B), u(!1), l(!0);
      }, "image/png"));
    },
    reset: () => {
      j(null), N(!1), u(!0), l(!1);
    },
    startCamera: F,
    stopCamera: R,
    setImage: j,
    toggleFlash: async () => {
      var i;
      const s = _.current;
      if (!s) return;
      const o = (i = s.getCapabilities) == null ? void 0 : i.call(s);
      if (o != null && o.torch)
        try {
          await s.applyConstraints({
            advanced: [{
              torch: !S
            }]
          }), N((p) => !p);
        } catch {
        }
    },
    flashOn: S,
    hasFlash: z,
    videoReady: k,
    setIsActive: u
  };
}
const $e = ({
  name: e,
  fromPersistence: r
}) => r ? localStorage.getItem(e) : sessionStorage.getItem(e), Se = ({
  name: e,
  value: r,
  shouldPersist: n
}) => {
  n ? localStorage.setItem(e, r) : sessionStorage.setItem(e, r);
}, Pe = ({
  name: e,
  fromPersistence: r
}) => {
  r ? localStorage.removeItem(e) : sessionStorage.removeItem(e);
}, Me = ({
  name: e,
  fromPersistence: r
}) => {
  const n = $e({
    name: e,
    fromPersistence: r
  });
  if (n)
    try {
      const l = JSON.parse(n), h = Date.now();
      if (l.ttl > h)
        return l.value;
    } catch {
      return;
    }
}, We = ({
  name: e,
  value: r,
  fromPersistence: n,
  ttl: l = 0
}) => {
  const m = {
    ttl: Date.now() + l,
    value: r
  };
  Se({
    name: e,
    value: JSON.stringify(m),
    shouldPersist: n
  });
}, Ie = {
  getItem: $e,
  setItem: Se,
  removeItem: Pe,
  getItemWithTTL: Me,
  setItemWithTTL: We
}, Xe = (e) => {
  const r = e.toLowerCase(), n = /\.(php|sh|exe|js|bat|py|rb|pl|cmd|scr|dll|jar|msi)\.(jpg|jpeg|png|gif|tif|tiff|bmp|webp)$/, l = /\.(php|sh|exe|js|bat|py|rb|pl|cmd|scr|dll|jar|msi)$/;
  return n.test(r) || l.test(r);
}, qe = async (e) => {
  const r = await (e == null ? void 0 : e.slice(0, 4).arrayBuffer());
  return new Uint8Array(r).reduce((l, h) => l + h.toString(16).padStart(2, "0"), "");
}, Ve = (e, r) => {
  const n = e.toLowerCase().split(".");
  if (n.length < 2) return !1;
  const l = n.pop();
  return !(!r.includes(l) || n.some((h) => r.includes(h)));
}, _e = async (e) => {
  var m;
  const r = {
    png: "89504e47",
    jpg: ["ffd8ffe0", "ffd8ffe1", "ffd8ffe2", "ffd8ffee3", "ff8d8ffe8"]
  }, n = ["png", "jpg", "jpeg"];
  if (Xe(e.name) || !Ve(e.name, n)) return !1;
  const l = ((m = e.name.split(".").pop()) == null ? void 0 : m.toLowerCase()) || "", h = await qe(e);
  return !!(l === "png" && h === r.png || (l === "jpg" || l === "jpeg") && r.jpg.includes(h));
}, Ye = async (e, r, n) => e.size > 20971520 ? (n(r.maxSize), !1) : await _e(e) ? (n(null), !0) : (n(r.unsupportedType), !1), Ze = async (e, r, n, l, h, m, g, v) => {
  var _, w, j, b;
  if (!e && !((w = (_ = r.current) == null ? void 0 : _.files) != null && w[0])) return;
  const x = v ? M.UPLOAD : M.CAMERA;
  try {
    l(!0);
    let u;
    if (e != null && e.startsWith("blob:"))
      u = await fetch(e).then((S) => S.blob()), URL.revokeObjectURL(e);
    else {
      const S = (b = (j = r.current) == null ? void 0 : j.files) == null ? void 0 : b[0];
      if (!S) {
        n(m.unexpectedError), l(!1);
        return;
      }
      if (!Ye(S, m, n)) {
        l(!1);
        return;
      }
      u = S;
    }
    g(M.UPLOADING);
    const C = await h(u);
    (C == null ? void 0 : C.status) === "success" ? n(null) : (n(m.unexpectedError), g(x), l(!1));
  } catch {
    g(x), n(m.unexpectedError), l(!1);
  }
}, Je = (e) => {
  const r = Ie.getItem({
    name: e,
    fromPersistence: !0
  });
  try {
    return r ? JSON.parse(r) : void 0;
  } catch {
    return;
  }
}, Ge = (e, r, n = !1) => {
  {
    const l = n ? r : JSON.stringify(r);
    Ie.setItem({
      name: e,
      value: l,
      shouldPersist: !0
    });
  }
}, He = ({
  openCamera: e,
  initialFacingMode: r,
  errorMessageData: n,
  toggleSearchByImage: l,
  handleSearchByImageData: h,
  updateSateliteTrack: m,
  handleAbort: g
}) => {
  const v = re(null), [x, _] = L(null), [w, j] = L(!1), [b, u] = L(!1), [C, T] = L(!1), [S, N] = L(M.CAMERA), {
    videoRef: z,
    canvasRef: I,
    image: k,
    switchCamera: A,
    captureImage: R,
    reset: F,
    setImage: W,
    stopCamera: d,
    toggleFlash: c,
    flashOn: f,
    startCamera: t,
    videoReady: s,
    facingMode: o
  } = Ue(r, u, _, T, N, n), i = o === "user";
  return q(() => {
    e || (F(), d());
  }, [e, F, d]), q(() => () => {
    k != null && k.startsWith("blob:") && URL.revokeObjectURL(k), d();
  }, [k, d]), q(() => {
    x && (m == null || m(x));
  }, [x, m]), q(() => {
    if (e)
      return (async () => {
        try {
          await t();
        } catch {
          N(M.UPLOAD), u(!0), _(n.unexpectedError);
        }
      })(), d;
  }, [e]), {
    fileInputRef: v,
    error: x,
    setError: _,
    spinner: w,
    permissionDenied: b,
    capturedFromCamera: C,
    videoRef: z,
    canvasRef: I,
    image: k,
    switchCamera: A,
    captureImage: R,
    handleUploadClick: () => {
      var te;
      return (te = v.current) == null ? void 0 : te.click();
    },
    handleFileChange: async (te) => {
      var ae;
      try {
        j(!0);
        const xe = 20 * 1024 * 1024, ce = (ae = te.target.files) == null ? void 0 : ae[0];
        if (!ce) return;
        if (!await _e(ce)) {
          _(n.unsupportedType);
          return;
        }
        if (ce.size > xe) {
          _(n.maxSize);
          return;
        }
        k != null && k.startsWith("blob:") && URL.revokeObjectURL(k);
        const Fe = URL.createObjectURL(ce);
        F(), W(Fe), d(), T(!1), _(null), N(M.PREVIEW);
      } catch {
        _(n.unexpectedError);
      } finally {
        j(!1), v.current && (v.current.value = "");
      }
    },
    handleReset: ({
      isError: te = !1,
      isGoBack: ae = !1
    } = {}) => {
      const xe = b ? M.UPLOAD : M.CAMERA;
      F(), e || d(), e && !b && !ae && t(), e && !b && ae && d(), S === M.UPLOADING && g(), _(null), j(!1), N(xe), !k && !te && l();
    },
    handleUpload: () => {
      Ze(k, v, _, j, h, n, N, b);
    },
    flashOn: f,
    toggleFlash: c,
    videoReady: s,
    isFrontCamera: i
  };
}, Qe = "1024px", Re = "#0072ce", Ke = "#f1f1f1", ve = "#a6a6a6", De = "#f9f9f9", H = "#343e49", et = "#636363", Ce = "#bbbbbb", tt = "#404040", Be = "#FFDDE4", st = "#63000F", he = "#ffffff", G = "#fefeff", E = "#333333", je = "#717171", P = "'Lato', sans-serif", oe = "12px", J = "14px", it = "16px", Ne = "20px", me = 1, be = 120, nt = 170, rt = 999, at = 9999999, ie = ["body{overflow:hidden !important;}", `.searchByImage--container.jsx-2860424014{position:fixed;top:0;left:0;right:0;bottom:0;z-index:${at};display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;height:100dvh;color:${he};font-family:${P};}`, `.searchByImage--previewContainer.jsx-2860424014{background-color:${tt};height:calc(100dvh - 48px);}`, `.searchByImage--previewContainer.searchByImage--light.jsx-2860424014{background:${G};}`];
ie.__hash = "2860424014";
function ze(e) {
  var r, n, l = "";
  if (typeof e == "string" || typeof e == "number") l += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var h = e.length;
    for (r = 0; r < h; r++) e[r] && (n = ze(e[r])) && (l && (l += " "), l += n);
  } else for (n in e) e[n] && (l && (l += " "), l += n);
  return l;
}
function ot() {
  for (var e, r, n = 0, l = "", h = arguments.length; n < h; n++) (e = arguments[n]) && (r = ze(e)) && (l && (l += " "), l += r);
  return l;
}
const lt = ot, ct = (e) => /* @__PURE__ */ Q.createElement("svg", { viewBox: "0 0 21 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ Q.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.5 1.75C5.94365 1.75 2.25 5.44365 2.25 10C2.25 14.5563 5.94365 18.25 10.5 18.25C15.0563 18.25 18.75 14.5563 18.75 10C18.75 5.44365 15.0563 1.75 10.5 1.75ZM0.75 10C0.75 4.61522 5.11522 0.25 10.5 0.25C15.8848 0.25 20.25 4.61522 20.25 10C20.25 15.3848 15.8848 19.75 10.5 19.75C5.11522 19.75 0.75 15.3848 0.75 10Z", fill: "currentColor" }), /* @__PURE__ */ Q.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.5 12.25C11.1213 12.25 11.625 12.7537 11.625 13.375C11.625 13.9963 11.1213 14.5 10.5 14.5C9.87868 14.5 9.375 13.9963 9.375 13.375C9.375 12.7537 9.87868 12.25 10.5 12.25ZM11.25 10C11.25 10.4142 10.9142 10.75 10.5 10.75C10.0858 10.75 9.75 10.4142 9.75 10V6.25C9.75 5.83579 10.0858 5.5 10.5 5.5C10.9142 5.5 11.25 5.83579 11.25 6.25V10Z", fill: "currentColor" })), ye = (e) => /* @__PURE__ */ Q.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: 2, ...e }, /* @__PURE__ */ Q.createElement("path", { strokeLinecap: "round", strokeLinejoin: "round", d: "M1 1 L23 23" }), /* @__PURE__ */ Q.createElement("path", { strokeLinecap: "round", strokeLinejoin: "round", d: "M23 1 L1 23" })), D = [`.errorMessage.jsx-498746409{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;background-color:${Be};color:${E};padding:12px;border-radius:4px;font-family:${P};line-height:20px;font-size:${J};position:fixed;width:296px;gap:12px;left:50%;-webkit-transform:translateX(-50%);-ms-transform:translateX(-50%);transform:translateX(-50%);bottom:17%;z-index:${rt};}`, ".errorMessage__permissionDenied.jsx-498746409{bottom:12%;}", `.errorMessage__icon.jsx-498746409{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;color:${st};}`, `.errorMessage__text.jsx-498746409{-webkit-flex:1;-ms-flex:1;flex:1;color:${E};}`, ".errorMessage__close.jsx-498746409{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;cursor:pointer;padding:4px;}", ".errorMessage__close.jsx-498746409:focus{outline:none;}"];
D.__hash = "498746409";
const dt = ({
  message: e = "",
  onClose: r = () => {
  },
  className: n,
  ...l
}) => {
  const h = lt("errorMessage", n);
  return /* @__PURE__ */ y(K, { children: [
    /* @__PURE__ */ a(Y, { id: D.__hash, children: D }),
    /* @__PURE__ */ y("div", { ...l, "data-testid": "error-message", className: `jsx-${D.__hash} ` + (h || ""), children: [
      /* @__PURE__ */ a("div", { className: `jsx-${D.__hash} errorMessage__icon`, children: /* @__PURE__ */ a(ct, { width: 24, height: 24 }) }),
      /* @__PURE__ */ a("div", { className: `jsx-${D.__hash} errorMessage__text`, children: e }),
      /* @__PURE__ */ a("div", { tabIndex: 0, onClick: r, className: `jsx-${D.__hash} errorMessage__close`, children: /* @__PURE__ */ a(ye, { width: 12, height: 12 }) })
    ] })
  ] });
}, ne = [`.spinner.jsx-325551274{background:${E};border:${E};}`, `.spinner-background.jsx-325551274{position:absolute;top:50%;left:50%;-webkit-transform:translate(-50%,-100%);-ms-transform:translate(-50%,-100%);transform:translate(-50%,-100%);z-index:${be};display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;padding:8px;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;background:rgba(254,254,255,0.8);border-radius:4px;gap:4px;}`, `@media (min-width:${Qe}){.spinner-background.jsx-325551274{-webkit-transform:translate(-50%,-50%);-ms-transform:translate(-50%,-50%);transform:translate(-50%,-50%);max-width:192px;}}`, ".with-text.jsx-325551274{padding:16px 8px;}", `#spinner.jsx-325551274{z-index:${me};width:36px;height:36px;border:5px solid ${Ce};border-radius:50%;border-top:5px solid ${H};border-left:5px solid ${H};border-right:5px solid ${H};-webkit-animation:spin 2s linear infinite;-webkit-animation:spin-jsx-325551274 2s linear infinite;animation:spin-jsx-325551274 2s linear infinite;}`, "@-webkit-keyframes spin-jsx-325551274{0%{-webkit-transform:rotate(0deg);-ms-transform:rotate(0deg);transform:rotate(0deg);}100%{-webkit-transform:rotate(360deg);-ms-transform:rotate(360deg);transform:rotate(360deg);}}", "@keyframes spin-jsx-325551274{0%{-webkit-transform:rotate(0deg);-ms-transform:rotate(0deg);transform:rotate(0deg);}100%{-webkit-transform:rotate(360deg);-ms-transform:rotate(360deg);transform:rotate(360deg);}}", `.spinner-text.jsx-325551274{color:${E};text-align:center;font-size:${oe};line-height:14px;font-family:${P};}`];
ne.__hash = "325551274";
function ft(e, r = "", n, l = 12e3) {
  const [h, m] = L(e ? r : "");
  return q(() => {
    if (!e) {
      m("");
      return;
    }
    if (m(r), !n) return;
    const g = setTimeout(() => {
      m(n);
    }, l);
    return () => clearTimeout(g);
  }, [e, r, n, l]), h;
}
const pe = ({
  show: e,
  text: r,
  delayedText: n,
  delayMs: l = 12e3
}) => {
  const h = ft(e, r, n, l);
  return e ? /* @__PURE__ */ y(K, { children: [
    /* @__PURE__ */ a(Y, { id: ne.__hash, children: ne }),
    /* @__PURE__ */ y("div", { "data-testId": "spinner", className: `jsx-${ne.__hash} spinner-background ${h ? "with-text" : ""}`, children: [
      /* @__PURE__ */ a("div", { id: "spinner", className: `jsx-${ne.__hash}` }),
      h && /* @__PURE__ */ a("span", { className: `jsx-${ne.__hash} spinner-text`, children: h })
    ] })
  ] }) : null;
}, Z = [".searchByImage--preview.jsx-3954138401{-webkit-flex:1;-ms-flex:1;flex:1;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;position:relative;height:100%;text-align:center;}", ".searchByImage--permissionDeniedUI.jsx-3954138401{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;padding:20px;}", `.searchByImage--titleText.jsx-3954138401{font-size:${Ne};font-family:${P};color:${E};line-height:24px;}`, `.searchByImage--descText.jsx-3954138401{font-size:${J};color:${E};font-family:${P};margin-top:4px;}`, `.searchByImage--uploadButton.jsx-3954138401{background-color:${Re};color:${he};padding:0px 32px;font-family:${P};font-size:${it};font-weight:700;border:none;cursor:pointer;height:44px;margin-top:40px;border-radius:4px;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;-webkit-align-self:stretch;-ms-flex-item-align:stretch;align-self:stretch;}`];
Z.__hash = "3954138401";
const ht = ({
  title: e,
  description: r,
  uploadButtonLabel: n,
  onUploadClick: l,
  spinner: h = !1,
  spinnerData: m
}) => /* @__PURE__ */ y("div", { className: `jsx-${Z.__hash} searchByImage--preview`, children: [
  /* @__PURE__ */ a(pe, { show: h, text: m == null ? void 0 : m.cameraLoaderText }),
  /* @__PURE__ */ y("div", { "data-testid": "searchByImage--permissionDeniedUI", className: `jsx-${Z.__hash} searchByImage--permissionDeniedUI`, children: [
    /* @__PURE__ */ a("img", { src: "https://images.sodimac.com/v3/assets/blt6a203fe6c6a9b6dd/blt70476876308a16a2/CameraPermission.svg", alt: "Camera Permission", className: `jsx-${Z.__hash}` }),
    /* @__PURE__ */ a("div", { className: `jsx-${Z.__hash} searchByImage--titleText`, children: e }),
    /* @__PURE__ */ a("div", { className: `jsx-${Z.__hash} searchByImage--descText`, children: r }),
    /* @__PURE__ */ a("div", { onClick: l, "data-testid": "searchByImage--uploadButton", className: `jsx-${Z.__hash} searchByImage--uploadButton`, children: n })
  ] }),
  /* @__PURE__ */ a(Y, { id: Z.__hash, children: Z })
] }), U = [`.searchByImage--bottomControls.jsx-173379363{position:absolute;left:0;right:0;bottom:0;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-webkit-justify-content:space-between;-ms-flex-pack:justify;justify-content:space-between;padding:0px 28px 28px;background-color:transparent;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;z-index:${be};}`, `.searchByImage--controlBtn.jsx-173379363{width:42px;height:42px;border-radius:50%;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;background:${E};position:relative;z-index:${me};cursor:pointer;}`, `.searchByImage--controlBtn.jsx-173379363::after{content:'';position:absolute;width:53px;height:53px;border-radius:50%;background:${E};opacity:0.7;pointer-events:none;z-index:${me};}`, `.searchByImage--cameraIcon.jsx-173379363{background:${G};width:66px;height:66px;}`, `.searchByImage--cameraIcon.jsx-173379363::after{width:77px;height:77px;background:${G};}`, `.searchByImage--controlBtn.jsx-173379363 img.jsx-173379363{z-index:${be};position:relative;}`, ".searchByImage--disabled.jsx-173379363{pointer-events:none;opacity:0.5;}"];
U.__hash = "173379363";
const mt = ({
  hasImage: e,
  isLoading: r,
  onUploadClick: n,
  onCapture: l,
  onSwitchCamera: h,
  onReset: m,
  onUpload: g,
  videoReady: v,
  error: x
}) => /* @__PURE__ */ y("div", { className: `jsx-${U.__hash} searchByImage--bottomControls`, children: [
  e ? !r && /* @__PURE__ */ y(K, { children: [
    /* @__PURE__ */ a("div", { onClick: m, className: `jsx-${U.__hash} searchByImage--controlBtn searchByImage--closeIcon`, children: /* @__PURE__ */ a("img", { src: "https://images.sodimac.com/v3/assets/blt6a203fe6c6a9b6dd/bltbba96669a8bd17a8/Close.svg", alt: "Close icon", className: `jsx-${U.__hash}` }) }),
    !x && /* @__PURE__ */ a("div", { onClick: g, className: `jsx-${U.__hash} searchByImage--controlBtn searchByImage--acceptIcon`, children: /* @__PURE__ */ a("img", { src: "https://images.sodimac.com/v3/assets/blt6a203fe6c6a9b6dd/bltc5fc857d6dcbde28/Accept.svg", alt: "Accept icon", className: `jsx-${U.__hash}` }) })
  ] }) : /* @__PURE__ */ y(K, { children: [
    /* @__PURE__ */ a("div", { onClick: n, className: `jsx-${U.__hash} searchByImage--controlBtn searchByImage--galleryIcon`, children: /* @__PURE__ */ a("img", { src: "https://images.sodimac.com/v3/assets/blt6a203fe6c6a9b6dd/blt10c6ea0710c1a7c4/Gallery.svg", alt: "gallery icon", className: `jsx-${U.__hash} searchByImage--zIndex` }) }),
    /* @__PURE__ */ a("div", { onClick: v ? l : void 0, className: `jsx-${U.__hash} searchByImage--controlBtn searchByImage--cameraIcon ${v ? "" : "searchByImage--disabled"}`, children: /* @__PURE__ */ a("img", { src: "https://images.sodimac.com/v3/assets/blt6a203fe6c6a9b6dd/blt2e9c3ad3a013aef7/Camera.svg", alt: "camera icon", className: `jsx-${U.__hash} searchByImage--zIndex` }) }),
    /* @__PURE__ */ a("div", { onClick: h, "data-testId": "searchByImage--flipCameraButton", className: `jsx-${U.__hash} searchByImage--controlBtn searchByImage--reverseIcon`, children: /* @__PURE__ */ a("img", { src: "https://images.sodimac.com/v3/assets/blt6a203fe6c6a9b6dd/blt1f16f52efef43cf5/Reverse.svg", alt: "reverse icon", className: `jsx-${U.__hash} searchByImage--zIndex` }) })
  ] }),
  /* @__PURE__ */ a(Y, { id: U.__hash, children: U })
] }), ee = [".searchByImage--preview.jsx-3907637537{-webkit-flex:1;-ms-flex:1;flex:1;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;position:relative;height:100%;text-align:center;}", ".searchByImage--video.jsx-3907637537{width:100%;height:100%;object-fit:cover;}", ".searchByImage--front-camera.jsx-3907637537{-webkit-transform:scaleX(-1);-ms-transform:scaleX(-1);transform:scaleX(-1);}", ".searchByImage--previewImage.jsx-3907637537{max-width:100%;max-height:100%;object-fit:contain;height:calc(100dvh - 48px);}", ".captured-image.jsx-3907637537{object-fit:cover;}"];
ee.__hash = "3907637537";
const pt = ({
  image: e,
  videoRef: r,
  canvasRef: n,
  spinner: l,
  onUploadClick: h,
  onCapture: m,
  onSwitchCamera: g,
  onReset: v,
  onUpload: x,
  videoReady: _,
  spinnerData: w,
  error: j,
  capturedFromCamera: b,
  isFrontCamera: u
}) => /* @__PURE__ */ y("div", { "data-testId": "searchByImage--preview", className: `jsx-${ee.__hash} searchByImage--preview`, children: [
  /* @__PURE__ */ a(pe, { show: l, text: e ? w == null ? void 0 : w.submitImageText : w == null ? void 0 : w.cameraLoaderText, delayedText: w == null ? void 0 : w.submitImageDelayedText }),
  e ? /* @__PURE__ */ a("img", { src: e, alt: "Preview", className: `jsx-${ee.__hash} searchByImage--previewImage ${b ? "captured-image" : ""} ${u ? "searchByImage--front-camera" : ""}` }, e) : /* @__PURE__ */ a("video", { ref: r, autoPlay: !0, playsInline: !0, muted: !0, className: `jsx-${ee.__hash} searchByImage--video ${u ? "searchByImage--front-camera" : ""}` }),
  /* @__PURE__ */ a("canvas", { ref: n, style: {
    display: "none"
  }, className: `jsx-${ee.__hash}` }),
  /* @__PURE__ */ a(mt, { hasImage: !!e, isLoading: l, onUploadClick: h, onCapture: m, onSwitchCamera: g, onReset: v, onUpload: x, videoReady: _, error: j }),
  /* @__PURE__ */ a(Y, { id: ee.__hash, children: ee })
] }), xt = (e) => /* @__PURE__ */ Q.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 13 24", fill: "none", stroke: "currentColor", strokeWidth: 2, ...e }, /* @__PURE__ */ Q.createElement("path", { strokeLinecap: "round", strokeLinejoin: "round", d: "M12 23 L1 12 L12 1" })), de = {
  sizes: {
    arrowSize: "10px",
    tooltipSpacing: "14px",
    horizontalOffset: "25px"
  }
}, V = [".tooltip__wrapper.jsx-3349961459{display:inline-block;position:relative;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;}", `.tooltip__tip.jsx-3349961459{position:absolute;border-radius:4px;left:50%;-webkit-transform:translateX(-50%);-ms-transform:translateX(-50%);transform:translateX(-50%);padding:14px;color:${he};background:${E};font-family:${P};font-size:${J};font-weight:400;line-height:20px;z-index:${nt};text-align:justify;width:232px;height:140px;max-width:320px;max-height:260px;box-sizing:border-box;}`, `.tooltip__tip.jsx-3349961459::before{content:' ';left:50%;border:solid transparent;height:0;width:0;position:absolute;pointer-events:none;border-width:${de.sizes.arrowSize};margin-left:calc(-${de.sizes.arrowSize} * 1);}`, `.tooltip__tip.bottom.jsx-3349961459{top:calc(100% + ${de.sizes.tooltipSpacing});left:auto;right:0;-webkit-transform:none;-ms-transform:none;transform:none;}`, `.tooltip__tip.bottom.jsx-3349961459::before{bottom:100%;right:${de.sizes.horizontalOffset};left:auto;margin-left:0;border-bottom-color:${E};}`, ".tooltip__tip__message.jsx-3349961459{width:228px;height:60px;}", ".tooltip__tip__close__icon.jsx-3349961459{position:absolute;top:8px;right:4px;cursor:pointer;}", `.tooltip__tip__close__link.jsx-3349961459{position:absolute;bottom:16px;right:16px;cursor:pointer;color:${he};font-size:${oe};line-height:16px;font-weight:700px;-webkit-text-decoration:underline;text-decoration:underline;}`, `.tooltip__tip__close__button.jsx-3349961459{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;position:absolute;bottom:16px;right:16px;cursor:pointer;color:${H};font-size:${oe};line-height:16px;padding:0 24px;height:24px;font-weight:700;border-radius:4px;background:${G};}`, ".tooltip__fade-in.jsx-3349961459{opacity:0;-webkit-animation:fadeInSlide-jsx-3349961459 0.3s ease-out forwards;animation:fadeInSlide-jsx-3349961459 0.3s ease-out forwards;}", "@-webkit-keyframes fadeInSlide-jsx-3349961459{from{opacity:0;-webkit-transform:translateY(10px);-ms-transform:translateY(10px);transform:translateY(10px);}to{opacity:1;-webkit-transform:translateY(0);-ms-transform:translateY(0);transform:translateY(0);}}", "@keyframes fadeInSlide-jsx-3349961459{from{opacity:0;-webkit-transform:translateY(10px);-ms-transform:translateY(10px);transform:translateY(10px);}to{opacity:1;-webkit-transform:translateY(0);-ms-transform:translateY(0);transform:translateY(0);}}"];
V.__hash = "3349961459";
const ut = (e = "cameraTooltip") => {
  const [r, n] = L(!1);
  return q(() => {
    Je(e) || n(!0);
  }, [e]), {
    showTooltip: r,
    dismissTooltip: () => {
      Ge(e, !0), n(!1);
    }
  };
}, gt = ({
  closeButtonLabel: e = "",
  message: r,
  children: n,
  image: l,
  ...h
}) => {
  const [m, g] = L(!1), {
    showTooltip: v,
    dismissTooltip: x
  } = ut();
  q(() => {
    if (v) {
      const j = setTimeout(() => {
        g(!0);
      }, 1500);
      return () => clearTimeout(j);
    }
  }, [v]);
  const _ = () => {
    x(), g(!1);
  }, w = () => {
    g((j) => !j);
  };
  return l ? /* @__PURE__ */ a("div", { className: "tooltip__wrapper", "data-testId": "tooltip-trigger", children: n }) : /* @__PURE__ */ y(K, { children: [
    /* @__PURE__ */ a(Y, { id: V.__hash, children: V }),
    /* @__PURE__ */ y("div", { className: `jsx-${V.__hash} tooltip__wrapper`, children: [
      /* @__PURE__ */ a("div", { onClick: w, "data-testId": "tooltip-trigger", className: `jsx-${V.__hash}`, children: n }),
      m && /* @__PURE__ */ y("div", { ...h, className: `jsx-${V.__hash} tooltip__tip bottom tooltip__fade-in`, children: [
        /* @__PURE__ */ a("span", { className: `jsx-${V.__hash} tooltip__tip__message`, children: r }),
        /* @__PURE__ */ a("div", { onClick: _, className: `jsx-${V.__hash} tooltip__tip__close__button`, children: e }),
        /* @__PURE__ */ a("div", { "data-testId": "tooltip__tip__close__icon", className: `jsx-${V.__hash} tooltip__tip__close__icon`, children: /* @__PURE__ */ a("img", { height: 13, width: 13, src: "https://images.sodimac.com/v3/assets/blt6a203fe6c6a9b6dd/bltbba96669a8bd17a8/Close.svg", alt: "camera icon", onClick: _, className: `jsx-${V.__hash}` }) })
      ] })
    ] })
  ] });
}, X = [`.searchByImage--topBar.jsx-1009596295{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-webkit-justify-content:space-between;-ms-flex-pack:justify;justify-content:space-between;padding:4px 8px;height:48px;background:${G};color:${E};font-size:${J};font-weight:700;position:relative;box-shadow:0 2px 2px 0 rgba(29,29,29,0.1);box-sizing:border-box;}`, ".searchByImage--rightIcons.jsx-1009596295{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;}", `.searchByImage--icon.jsx-1009596295{color:${et};height:20px;width:20px;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;cursor:pointer;}`, ".searchByImage--info-icon.jsx-1009596295{margin-right:16px;}", ".searchByImage--title.jsx-1009596295{-webkit-flex:1;-ms-flex:1;flex:1;text-align:center;font-weight:bold;position:absolute;left:50%;top:50%;-webkit-transform:translate(-50%,-50%);-ms-transform:translate(-50%,-50%);transform:translate(-50%,-50%);}"];
X.__hash = "1009596295";
const bt = ({
  modalTitle: e,
  permissionDenied: r,
  flashOn: n,
  onBack: l,
  onToggleFlash: h,
  tooltipMessage: m,
  tooltipAccept: g,
  tooltipStyle: v,
  image: x
}) => /* @__PURE__ */ y("div", { className: `jsx-${X.__hash} searchByImage--topBar`, children: [
  /* @__PURE__ */ a("div", { "data-testId": "back-button", onClick: () => l({
    isGoBack: !0
  }), className: `jsx-${X.__hash} searchByImage--icon`, children: /* @__PURE__ */ a(xt, { width: 8, height: 14 }) }),
  /* @__PURE__ */ a("span", { className: `jsx-${X.__hash} searchByImage--title`, children: e }),
  !r && !x && /* @__PURE__ */ y("div", { className: `jsx-${X.__hash} searchByImage--rightIcons`, children: [
    /* @__PURE__ */ a("div", { className: `jsx-${X.__hash} searchByImage--icon searchByImage--info-icon`, children: /* @__PURE__ */ a(gt, { closeButtonLabel: g, message: m, style: v, image: x, children: /* @__PURE__ */ a("img", { src: "https://images.sodimac.com/v3/assets/blt6a203fe6c6a9b6dd/blt794db74a4d73b163/Info.svg", alt: "info icon", className: `jsx-${X.__hash}` }) }) }),
    /* @__PURE__ */ a("div", { "data-testId": "flash-button", onClick: h, className: `jsx-${X.__hash} searchByImage--icon`, children: /* @__PURE__ */ a("img", { src: "https://images.sodimac.com/v3/assets/blt6a203fe6c6a9b6dd/blt5b981c5ec6fd6473/Flash.svg", alt: "flash icon", className: `jsx-${X.__hash} ` + ((n ? "flashOn" : "") || "") }) })
  ] }),
  /* @__PURE__ */ a(Y, { id: X.__hash, children: X })
] }), yt = ({
  openCamera: e,
  toggleSearchByImage: r,
  initialFacingMode: n = "environment",
  isMobile: l,
  modalTitle: h = "",
  permissionDeniedPageData: m,
  errorMessageData: g,
  tooltipData: v,
  handleSearchByImageData: x,
  spinnerData: _,
  updateSateliteTrack: w,
  handleAbort: j
}) => {
  const {
    fileInputRef: b,
    error: u,
    spinner: C,
    permissionDenied: T,
    capturedFromCamera: S,
    videoRef: N,
    canvasRef: z,
    image: I,
    switchCamera: k,
    captureImage: A,
    handleUploadClick: R,
    handleFileChange: F,
    handleReset: W,
    handleUpload: d,
    flashOn: c,
    toggleFlash: f,
    videoReady: t,
    isFrontCamera: s
  } = He({
    openCamera: e,
    initialFacingMode: n,
    errorMessageData: g,
    toggleSearchByImage: r,
    handleSearchByImageData: x,
    updateSateliteTrack: w,
    handleAbort: j
  });
  if (!e || !l) return null;
  const {
    title: o = "",
    description: i = "",
    uploadButtonLabel: p = ""
  } = m || {}, {
    message: B = "",
    buttonText: O = "",
    style: le = {
      right: "-28px",
      borderRadius: "8px",
      padding: "24px 16px 16px"
    }
  } = v || {};
  return /* @__PURE__ */ y("div", { "data-testid": "searchByImage--container", className: `jsx-${ie.__hash} searchByImage--container`, children: [
    /* @__PURE__ */ a(bt, { modalTitle: h, isMobile: l, permissionDenied: T, flashOn: c, onBack: W, onToggleFlash: f, tooltipMessage: B, tooltipAccept: O, tooltipStyle: le, image: I }),
    /* @__PURE__ */ a("div", { className: `jsx-${ie.__hash} searchByImage--previewContainer ${T && !I ? "searchByImage--light" : ""}`, children: T && !I ? /* @__PURE__ */ a(ht, { title: o, description: i, uploadButtonLabel: p, onUploadClick: R, spinner: C, spinnerData: _ }) : /* @__PURE__ */ a(pt, { image: I, spinner: C, videoRef: N, canvasRef: z, onUploadClick: R, onCapture: A, onSwitchCamera: k, onReset: W, onUpload: d, videoReady: t, spinnerData: _, error: u, capturedFromCamera: S, isFrontCamera: s }) }),
    /* @__PURE__ */ a("input", { ref: b, type: "file", accept: ".jpg, .jpeg, .png", onChange: F, style: {
      display: "none"
    }, className: `jsx-${ie.__hash}` }),
    u && /* @__PURE__ */ a(dt, { message: u, className: `${T ? "errorMessage__permissionDenied" : ""}`, onClose: () => W({
      isError: !0
    }) }),
    /* @__PURE__ */ a(Y, { id: ie.__hash, children: ie })
  ] });
}, $ = [`.container.jsx-1919514633{padding:24px;background:${G};box-shadow:0 4px 20px 0px rgba(29,29,29,0.2);display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:18px;}`, ".title.jsx-1919514633{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-align-self:stretch;-ms-flex-item-align:stretch;align-self:stretch;}", ".close.jsx-1919514633{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;width:20px;height:20px;padding:5px 4.655px 4.655px 5px;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;border:none;background:none;cursor:pointer;}", `.title-text.jsx-1919514633{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:10px;-webkit-flex:1 0 0;-ms-flex:1 0 0;flex:1 0 0;color:${E};font-family:${P};font-size:${Ne};font-style:normal;font-weight:400;line-height:24px;}`, ".content.jsx-1919514633{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-webkit-align-items:flex-start;-webkit-box-align:flex-start;-ms-flex-align:flex-start;align-items:flex-start;gap:12px;-webkit-align-self:stretch;-ms-flex-item-align:stretch;align-self:stretch;}", `.content-text.jsx-1919514633{color:${E};font-family:${P};font-size:${J};font-style:normal;font-weight:400;line-height:20px;}`, `.corresponding-text.jsx-1919514633{color:${E};font-family:${P};font-size:${oe};line-height:16px;}`, `.content-error.jsx-1919514633{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;padding:12px;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:12px;-webkit-align-self:stretch;-ms-flex-item-align:stretch;align-self:stretch;border-radius:4px;background:${Be};box-shadow:0px 2px 2px 0px rgba(29,29,29,0.1);}`, `.upload-container.jsx-1919514633{border-radius:4px;border:2px dashed ${ve};background:${Ke};width:100%;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;cursor:pointer;}`, `.loader.jsx-1919514633{background:${E};border:${E};}`, `.loader-background.jsx-1919514633{height:68px;width:68px;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;padding:16px;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:10px;border-radius:4px;opacity:0.8;background:${G};}`, `#loader.jsx-1919514633{z-index:${me};width:36px;height:36px;margin:-5px 0 0 -5px;border:5px solid ${Ce};border-radius:50%;border-top:5px solid ${H};border-left:5px solid ${H};border-right:5px solid ${H};-webkit-animation:spin 2s linear infinite;-webkit-animation:spin-jsx-1919514633 2s linear infinite;animation:spin-jsx-1919514633 2s linear infinite;}`, "@-webkit-keyframes spin{0%.jsx-1919514633{-webkit-transform:rotate(0deg);}100%.jsx-1919514633{-webkit-transform:rotate(360deg);}}", "@-webkit-keyframes spin-jsx-1919514633{0%{-webkit-transform:rotate(0deg);-ms-transform:rotate(0deg);transform:rotate(0deg);}100%{-webkit-transform:rotate(360deg);-ms-transform:rotate(360deg);transform:rotate(360deg);}}", "@keyframes spin-jsx-1919514633{0%{-webkit-transform:rotate(0deg);-ms-transform:rotate(0deg);transform:rotate(0deg);}100%{-webkit-transform:rotate(360deg);-ms-transform:rotate(360deg);transform:rotate(360deg);}}", `.error-text.jsx-1919514633{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-align-items:flex-start;-webkit-box-align:flex-start;-ms-flex-align:flex-start;align-items:flex-start;gap:4px;-webkit-flex:1 0 0;-ms-flex:1 0 0;flex:1 0 0;color:${E};font-family:${P};font-size:${J};font-style:normal;font-weight:400;line-height:20px;}`, ".img.jsx-1919514633{width:100%;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;padding:0px 5px;height:240px;}", "@media (min-width:1920px){.img.jsx-1919514633{height:400px;}}", "img.jsx-1919514633{width:100%;height:190px;}", "@media (min-width:1920px){img.jsx-1919514633{height:auto;}}", "img.jsx-1919514633{width:100%;}", ".preview-image.jsx-1919514633{padding:8px;position:relative;}", ".preview.jsx-1919514633{position:absolute;}", ".footer.jsx-1919514633{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-pack:end;-webkit-justify-content:flex-end;-ms-flex-pack:end;justify-content:flex-end;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:8px;-webkit-align-self:stretch;-ms-flex-item-align:stretch;align-self:stretch;-webkit-flex-wrap:wrap;-ms-flex-wrap:wrap;flex-wrap:wrap;}", `.btn.jsx-1919514633{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;height:32px;max-width:406px;max-height:32px;padding:0px 32px;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;border-radius:4px;font-family:${P};font-size:${J};font-style:normal;font-weight:700;line-height:16px;border:transparent;cursor:pointer;}`, `.primary.jsx-1919514633{background:${Re};color:${G};}`, `.secondary.jsx-1919514633{background:${G};color:${H};}`, `.disabled.jsx-1919514633{background-color:${De};color:${ve};}`, ".background-text.jsx-1919514633{display:grid;}", `.text.jsx-1919514633{color:${je};text-align:center;font-family:${P};font-size:${J};font-style:normal;font-weight:400;line-height:20px;}`, `.line1-bold.jsx-1919514633{color:${je};font-family:${P};font-size:${J};font-style:normal;font-weight:700;line-height:20px;-webkit-text-decoration-line:underline;text-decoration-line:underline;-webkit-text-decoration-style:solid;text-decoration-style:solid;-webkit-text-decoration-skip-ink:none;text-decoration-skip-ink:none;-webkit-text-decoration-thickness:auto;text-decoration-thickness:auto;text-underline-offset:auto;text-underline-position:from-font;}`, `.line2.jsx-1919514633{font-size:${oe};line-height:14px;}`];
$.__hash = "1919514633";
const fe = [".image.jsx-1975547009{border-radius:4px;width:100%;height:100%;box-sizing:border-box;}"];
fe.__hash = "1975547009";
const _t = ({
  ...e
}) => /* @__PURE__ */ y(K, { children: [
  /* @__PURE__ */ a(Y, { id: fe.__hash, children: fe }),
  /* @__PURE__ */ a("img", { ...e, className: `jsx-${fe.__hash} image` })
] }), wt = 20 * 1024 * 1024, kt = ({
  title: e = "",
  contentText: r = "",
  correspondingText: n = "",
  sizeErrorText: l = "",
  typeErrorText: h = "",
  unExpectedErrorText: m = "",
  primaryButtonText: g = "",
  secondaryButtonText: v = "",
  uploadText1: x = "",
  uploadText2: _ = "",
  uploadText3: w = "",
  handleSearchByImageData: j,
  closeModal: b,
  spinnerData: u,
  updateSateliteTrack: C,
  handleAbort: T
}) => {
  const [S, N] = L(null), [z, I] = L(""), [k, A] = L(!1), R = re(null), [F, W] = L(null), d = async (i) => {
    try {
      if (I(""), N(null), !i) return;
      if (R.current && (R.current.value = ""), !await _e(i)) {
        I(h);
        return;
      }
      if (i.size > wt) {
        I(l);
        return;
      }
      if (i.size === 0) {
        I(m);
        return;
      }
      A(!0);
      const p = new FileReader();
      p.onloadend = () => {
        A(!1), N(p.result);
      }, p.readAsDataURL(i), W(i);
    } catch {
      A(!1), I(m);
    }
  }, c = (i) => {
    var B;
    const p = (B = i.target.files) == null ? void 0 : B[0];
    d(p);
  }, f = (i) => {
    i.preventDefault();
  }, t = (i) => {
    if (i.preventDefault(), i.dataTransfer.files && i.dataTransfer.files[0]) {
      const p = i.dataTransfer.files[0];
      d(p);
    }
  }, s = async () => {
    if (A(!0), F) {
      const i = await (j == null ? void 0 : j(F));
      (i == null ? void 0 : i.status) === "success" ? (A(!1), b == null || b()) : (A(!1), I(m));
    }
  }, o = () => {
    N(null), I(""), b == null || b(), T == null || T();
  };
  return q(() => {
    z && (C == null || C(z));
  }, [z, C]), /* @__PURE__ */ y(K, { children: [
    /* @__PURE__ */ a(Y, { id: $.__hash, children: $ }),
    /* @__PURE__ */ y("div", { className: `jsx-${$.__hash} container`, children: [
      /* @__PURE__ */ y("div", { className: `jsx-${$.__hash} title`, children: [
        /* @__PURE__ */ a("span", { className: `jsx-${$.__hash} title-text`, children: e }),
        /* @__PURE__ */ a("button", { onClick: o, className: `jsx-${$.__hash} close`, children: /* @__PURE__ */ a(ye, {}) })
      ] }),
      /* @__PURE__ */ y("div", { className: `jsx-${$.__hash} content`, children: [
        /* @__PURE__ */ a("span", { className: `jsx-${$.__hash} content-text`, children: r }),
        z && /* @__PURE__ */ y("div", { className: `jsx-${$.__hash} content-error`, children: [
          /* @__PURE__ */ a("span", { className: `jsx-${$.__hash} error-text`, children: z }),
          /* @__PURE__ */ a("button", { "data-testid": "clear-icon", onClick: () => {
            I(""), N(null);
          }, className: `jsx-${$.__hash} close`, children: /* @__PURE__ */ a(ye, {}) })
        ] }),
        /* @__PURE__ */ y("div", { className: `jsx-${$.__hash} upload-container ${k || S ? "loader" : ""}`, children: [
          /* @__PURE__ */ a("input", { "data-testid": "file-input", type: "file", ref: R, accept: ".jpg,.jpeg,.png", onChange: c, style: {
            display: "none"
          }, className: `jsx-${$.__hash}` }),
          /* @__PURE__ */ y("div", { "data-testid": "drop-zone", onClick: k ? void 0 : () => {
            var i;
            return (i = R.current) == null ? void 0 : i.click();
          }, onDragOver: f, onDrop: t, className: `jsx-${$.__hash} ` + (!S && !k ? "img" : "img preview-image"), children: [
            !S && !k && /* @__PURE__ */ y("div", { className: `jsx-${$.__hash}`, children: [
              /* @__PURE__ */ a("img", { src: "https://images.sodimac.com/v3/assets/blt6a203fe6c6a9b6dd/blt448eef460557b18d/background.svg", alt: "Background", className: `jsx-${$.__hash}` }),
              /* @__PURE__ */ y("div", { className: `jsx-${$.__hash} background-text`, children: [
                /* @__PURE__ */ y("span", { className: `jsx-${$.__hash} text`, children: [
                  x,
                  /* @__PURE__ */ a("span", { className: `jsx-${$.__hash} text line1-bold`, children: _ })
                ] }),
                /* @__PURE__ */ a("span", { className: `jsx-${$.__hash} text line2`, children: w })
              ] })
            ] }),
            /* @__PURE__ */ a(pe, { show: k && !S, text: u == null ? void 0 : u.cameraLoaderText }),
            S && /* @__PURE__ */ y(K, { children: [
              /* @__PURE__ */ a(_t, { src: S, alt: "Preview", style: {
                objectFit: "contain"
              }, onError: () => {
                I(m), N(null);
              } }),
              /* @__PURE__ */ a(pe, { show: k, text: u == null ? void 0 : u.submitImageText, delayedText: u == null ? void 0 : u.submitImageDelayedText })
            ] })
          ] })
        ] }),
        S && !k && /* @__PURE__ */ a("div", { className: `jsx-${$.__hash} corresponding-text`, children: n })
      ] }),
      S && !k && /* @__PURE__ */ y("div", { className: `jsx-${$.__hash} footer`, children: [
        /* @__PURE__ */ a("button", { "data-testid": "cancel-button", onClick: () => {
          N(null), I("");
        }, className: `jsx-${$.__hash} btn secondary`, children: v }),
        /* @__PURE__ */ a("button", { onClick: s, disabled: z !== "", className: `jsx-${$.__hash} btn primary ${z !== "" ? "disabled" : ""}`, children: g })
      ] })
    ] })
  ] });
}, $t = (e) => e.isMobile || !1 ? /* @__PURE__ */ a(yt, { ...e }) : /* @__PURE__ */ a(kt, { ...e });
export {
  $t as SearchByImage,
  $t as default
};
